import Modal, {SimpleModalControls} from "../../components/Modal";
import {useTranslation} from "react-i18next";
import {getAxiosInstance} from "../../utils/axiosInstance";
import axios from "axios";
import {toast} from "react-toastify";
import {useNavigate} from "react-router-dom";

interface IDeleteConfirmationModalProps  extends SimpleModalControls {
    id?: string
}

const DeleteConfirmationModal = (props: IDeleteConfirmationModalProps) => {
    const {
        isOpen,
        onClose,
        id
    } = props;

    const { t } = useTranslation("translations");
    const navigate = useNavigate();

    const deleteProduct = async () => {
        if(!id) {
            toast.error(`No product id was set!`, {position: toast.POSITION.BOTTOM_RIGHT});
            return;
        }

        try {
            await getAxiosInstance().delete(`/Products/${id}`);
            navigate('/products')
        } catch (error) {
            if (axios.isAxiosError(error)) {
                toast.error(`${error.response?.data}`, {position: toast.POSITION.BOTTOM_RIGHT})
            } else {
                toast.error(`Couldn't delete the product: ${error}`, {position: toast.POSITION.BOTTOM_RIGHT});
            }
        }
    }

    return (
        <Modal
            size="lg"
            header={t("Confirm product deletion")}
            isOpen={isOpen}
            onClose={onClose}
            secondaryActionName={t("CONFIRM_PRODUCT_DELETION")}
            secondaryActionEnabled={true}
            secondaryAction={() => deleteProduct()}
        >
            <div className="text-red-500 text-4xl">
                {t("CONFIRM_PRODUCT_DELETION_TEXT")}
            </div>
        </Modal>
    )
}

export default DeleteConfirmationModal;